// WebcamCapture.js (ตัวอย่าง)
import React, { useRef } from "react";
import Webcam from "react-webcam";

function WebcamCapture({ onCapture, onCancel }) {
  const webcamRef = useRef(null);

  const capturePhoto = () => {
    if (webcamRef.current) {
      // getScreenshot() จะคืนค่า base64 ของภาพ
      const imageSrc = webcamRef.current.getScreenshot();
      // ส่งค่ากลับไปยัง parent component
      onCapture(imageSrc);
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat='image/jpeg'
        videoConstraints={{ facingMode: "environment" }} // ถ้าอยากใช้กล้องหลัง
        style={{ width: "100%", maxWidth: "400px" }}
      />
      <div style={{ marginTop: "10px" }}>
        <button onClick={capturePhoto}>ถ่ายรูป</button>
        <button onClick={onCancel}>ยกเลิก</button>
      </div>
    </div>
  );
}

export default WebcamCapture;
